{
  "ChartstyleoptionsPie2d": "Kuchen (2D)",
  "ChartstyleoptionsPie3d": "Kuchen (3D)",
  "ChartstyleoptionsDoughnut2d": "Donut (2D)",
  "ChartstyleoptionsDoughnut3d": "Donut (3D)",
  "ChartstyleoptionsLine": "Linie",
  "ChartstyleoptionsArea": "Bereich",
  "ChartstyleoptionsAreastacked": "Fläche (gestapelt)",
  "ChartstyleoptionsRadarpolararea": "Radar (Polargebiet)",
  "ChartstyleoptionsColumn2d": "Spalte (2D)",
  "ChartstyleoptionsColumn2dstacked": "Spalte (2D, gestapelt)",
  "ChartstyleoptionsColumn3d": "Spalte (3D)",
  "ChartstyleoptionsColumn3dstacked": "Spalte (3D, gestapelt)",
  "ChartstyleoptionsBar2d": "Balken (2D)",
  "ChartstyleoptionsBar2dstacked": "Balken (2D, gestapelt)",
  "ChartstyleoptionsBar3d": "Balken (3D)",
  "ChartstyleoptionsBar3dstacked": "Balken (3D, gestapelt)",
  "NAME": "ChartStyleOptions"
}